import axios from "axios";
import { global, globalMenu } from "@shared/libs/Global";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { dateToString } from "@shared/utils/DateUtils";
import * as converter from "@shared/utils/ValueConverterUtils";

//#region 재고관련
/** * pinventory 창고재고
 * * param: cd_biz, cd_item, cd_wh
 * * return qt_inv(Number)
 */
export const fnGetWhInv = async (params: any) => {
  try {
    const requestBody = {
      ...params,
      cd_firm: global.getState().userInfo.cd_firm,
    };

    const response = await axios.post("/snotes/getWhInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return Number(data);
  } catch (error) {
    return 0;
  }
};
//#endregion

/** * pinventory 창고재고 멀티
 * * param: cd_biz, item_wh_list(cd_item, cd_wh)
 * * return qt_inv, cd_item, cd_wh
 */
export const fnGetWhInvMulti = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const itemList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_wh_list: itemList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
      })),
    };

    const response = await axios.post("/snotes/getWhInvMulti", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};
//#endregion

//#region LOT관련
/** * LOT재고 cd_wh, cd_loc, no_ct, no_plt
 * * param: cd_biz, item_wh_list(cd_item, cd_wh, cd_loc), yn_valid(품목 유효 기간만 가져오기)
 * * return qt_inv, cd_item, no_lot, cd_wh, cd_loc, no_ct, no_plt
 */
export const fnGetWhLocLotCtPltInv = async (
  params: any,
  ynValid: boolean = false
) => {
  try {
    const isArray = Array.isArray(params);
    const lotList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_wh_list: lotList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
        cd_loc: item.cd_loc,
      })),
      yn_valid: ynValid === true ? "Y" : "N",
    };

    const response = await axios.post(
      "/snotes/getWhLocLotCtPltInv",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * LOT 재고전표 그대로(수량을 합치지 않음) cd_wh, cd_loc, no_ct, no_plt
 * * param: cd_biz, item_wh_list(cd_item, cd_wh, cd_loc)
 * * return no_io, no_line, no_line_lot, no_origin, no_line_origin, no_line_lot_origin, qt_inv, cd_item, no_lot, cd_wh, cd_loc, no_ct, no_plt
 */
export const fnGetWhLocLotCtPltInvDtl = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const lotList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_wh_list: lotList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
        cd_loc: item.cd_loc,
      })),
    };

    const response = await axios.post(
      "/snotes/getWhLocLotCtPltInvDtl",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * 거래처(구매)LOT를 포함한 LOT재고 cd_wh, cd_loc, no_ct, no_plt
 * * param: cd_biz, item_wh_list(cd_item, cd_wh, cd_loc)
 * * return qt_inv, cd_item, no_lot, no_lot_cust, cd_wh, cd_loc, no_ct, no_plt
 */
export const fnGetWhLocCustLotCtPltInv = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const lotList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_wh_list: lotList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
        cd_loc: item.cd_loc,
      })),
    };

    const response = await axios.post(
      "/snotes/getWhLocCustLotCtPltInv",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * LOt반품재고
 * * param: cd_biz, no_io_list(no_io, no_line), fg_io, fg_slip, no_barcode = ''
 * * return dt_io, cd_item, no_lot, no_ct, no_plt, qt_inv, no_lot_cust, no_io, no_line
 */
export const fnGetReturnLotInv = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const noIoList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      fg_io: isArray ? params[0]?.fg_io : params.fg_io,
      fg_slip: isArray ? params[0]?.fg_slip : params.fg_slip,
      no_io_list: noIoList.map((item: any) => ({
        no_io: item.no_io,
        no_line: item.no_line,
        no_barcode: item.no_barcode ?? "",
      })),
    };

    const response = await axios.post("/snotes/getReturnLotInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * LOT 프로젝트재고 cd_wh, cd_pjt cd_loc, no_ct, no_plt
 * * param: cd_biz, cd_pjt, item_wh_list(cd_item, cd_wh, cd_loc)
 * * return qt_inv, cd_item, no_lot, cd_wh, cd_pjt, cd_loc, no_ct, no_plt
 */
export const fnGetWhLocPjtLotCtPltInv = async (
  params: any,
  ynValid: boolean = false
) => {
  try {
    const isArray = Array.isArray(params);
    const lotList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      cd_pjt: isArray ? params[0]?.cd_pjt : params.cd_pjt,
      item_wh_list: lotList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
        cd_loc: item.cd_loc,
      })),
      yn_valid: ynValid === true ? "Y" : "N",
    };

    const response = await axios.post(
      "/snotes/getWhLocPjtLotCtPltInv",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};
//#endregion

//#region SN관련
/** * SN재고 cd_wh, no_ct, no_plt
 * * param: cd_biz, item_wh_list(cd_item, cd_wh), yn_valid(품목 유효 기간만 가져오기)
 * * return qt_inv, cd_item, no_sn, cd_wh, no_ct, no_plt, no_io, no_line, fg_slip
 */
export const fnGetWhSnInv = async (params: any, ynValid: boolean = false) => {
  try {
    const isArray = Array.isArray(params);
    const snList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_wh_list: snList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
      })),
      yn_valid: ynValid === true ? "Y" : "N",
    };

    const response = await axios.post("/snotes/getWhSnInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * SN반품재고
 * * param: cd_biz, no_io_list(no_io, no_line), fg_io, fg_slip, no_barcode = ''
 * * return dt_io, cd_item, no_sn, no_ct, no_plt, qt_inv, no_io, no_line, no_origin, no_line_origin
 */
export const fnGetReturnSnInv = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const noIoList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      fg_io: isArray ? params[0]?.fg_io : params.fg_io,
      fg_slip: isArray ? params[0]?.fg_slip : params.fg_slip,
      no_io_list: noIoList.map((item: any) => ({
        no_io: item.no_io,
        no_line: item.no_line,
        no_barcode: item.no_barcode ?? "",
      })),
    };

    const response = await axios.post("/snotes/getReturnSnInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * SN재고 cd_wh, cd_pjt, no_ct, no_plt
 * * param: cd_biz, cd_pjt, item_wh_list(cd_item, cd_wh)
 * * return qt_inv, cd_item, no_sn, cd_wh, cd_pjt, no_ct, no_plt, no_io, no_line, fg_slip
 */
export const fnGetWhPjtSnInv = async (
  params: any,
  ynValid: boolean = false
) => {
  try {
    const isArray = Array.isArray(params);
    const snList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      cd_pjt: isArray ? params[0]?.cd_pjt : params.cd_pjt,
      item_wh_list: snList.map((item: any) => ({
        cd_item: item.cd_item,
        cd_wh: item.cd_wh,
      })),
      yn_valid: ynValid === true ? "Y" : "N", // 26.09.22 kdy 품목 유효기간 체크(비프로젝트 API 와 동일)
    };

    const response = await axios.post("/snotes/getWhPjtSnInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * 이미 사용된 SN인지 확인 biz, item, sn || 단일/Array 둘 다 호환
 * * param: cd_biz, item_wh_list(cd_item, no_sn)
 * * return no_sn
 */
export const fnCheckDuplicateSn = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const snList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      item_sn_list: snList.map((item: any) => ({
        cd_item: item.cd_item,
        no_sn: item.no_sn,
      })),
    };

    const response = await axios.post("/snotes/checkDuplicateSn", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return "";
  }
};
//#endregion

//#region 공정재고관련
/** * 공정창고 QT, LOT 재고 cd_wh, no_wo
 * * param: item_wh_list(cd_item, cd_wh)
 * * return cd_matl, fg_unit, qt_inv, no_wo, cd_wh
 */
export const fnGetBfWhQtOrLotInv = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const itemList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      item_wh_list: itemList.map((item: any) => ({
        no_io: item.no_io,
        no_line_io: item.no_line_io,
      })),
    };

    const response = await axios.post(
      "/snotes/getBfWhQtOrLotInv",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * 공정창고 SN 재고 cd_wh, no_wo
 * * param: item_wh_list(cd_item, cd_wh)
 * * return cd_matl, fg_unit, qt_inv, no_wo, cd_wh, no_origin, no_line_origin
 */
export const fnGetBfWhSnInv = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const snList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      item_wh_list: snList.map((item: any) => ({
        no_io: item.no_io,
        no_line_io: item.no_line_io,
      })),
    };

    const response = await axios.post("/snotes/getBfWhSnInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};
//#endregion

//#region 바코드스캔관련
/** * 창고 LOT 재고 cd_wh, cd_loc
 * * param: cd_firm, cd_biz, cd_item, cd_wh, no_barcode, cd_loc
 * * return no_lot, qt_inv
 */
export const fnGetwhLocLotItemScan = async (params: any) => {
  try {
    const requestBody = {
      ...params,
      cd_firm: global.getState().userInfo.cd_firm,
    };

    const response = await axios.post("/snotes/whLocLotItemScan", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};

/** * 창고 LOT 멀티품목 재고 cd_wh, cd_loc
 * * param: cd_firm, cd_biz, item_list(cd_item), cd_wh, no_barcode, cd_loc
 * * return no_lot, qt_inv, cd_item, nm_item, dc_item_spec, dc_item_unit
 */
export const fnGetwhLocLotMultiItemScan = async (params: any) => {
  try {
    const isArray = Array.isArray(params);
    const itemList = isArray ? params : [params]; // 단일 객체면 배열로 감쌈

    const requestBody = {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_biz: isArray ? params[0]?.cd_biz : params.cd_biz,
      cd_wh: isArray ? params[0]?.cd_wh : params.cd_wh,
      no_barcode: isArray ? params[0]?.no_barcode : params.no_barcode,
      cd_loc: isArray ? params[0]?.cd_loc : params.cd_loc,
      item_list: itemList.map((item: any) => ({
        cd_item: item.cd_item,
      })),
    };

    const response = await axios.post(
      "/snotes/whLocLotMultiItemScan",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    return [];
  }
};
//#endregion

/** * 창고 바코드스캔(카톤팔레트포함) cd_wh
 * * param: cd_firm, cd_biz, cd_wh, no_barcode, yn_valid(품목 유효 기간 체크)
 * * return cd_firm, cd_biz, no_io, no_line, fg_unit, cd_wh, no_lot, no_sn, cd_item, nm_item,
 *          dc_item_spec, dc_item_unit, qt_inv, no_origin, no_line_origin
 */
export const fnGetBarcodeScanCtPltNonReqInv = async (
  params: any,
  barcodeList?: any[],
  ynValid: boolean = false
) => {
  try {
    const requestBody = {
      ...params,
      cd_firm: global.getState().userInfo.cd_firm,
      yn_valid: ynValid === true ? "Y" : "N",
    };

    const response = await axios.post(
      "/snotes/barcodeScanCtPltNonReqInv",
      requestBody,
      {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      }
    );

    const data = response.data;

    if (barcodeList && data.length > 0) {
      // 품목 유효 기간 체크
      if (ynValid) {
        if (
          converter.getString(data[0]["dt_valid"]) !== "" &&
          data[0]["dt_valid"] < dateToString(new Date())
        ) {
          await showDialog(
            "alter",
            `유효기간 통제품목\r\n유효기간 [${converter.formatToyyyyMMdd(data[0]["dt_valid"])}] 이 지난 재고입니다.`
          );
          throw new Error();
        }
      }

      const tpFifo = data[0]["tp_fifo"];
      // 선입선출 품목 재고 체크
      if (data[0]["yn_fifo"] === "Y" && tpFifo !== "N") {
        const requestBody2 = {
          cd_firm: global.getState().userInfo.cd_firm,
          cd_biz: params.cd_biz,
          cd_wh: params.cd_wh,
          cd_item: data[0]["cd_item"],
          dt_io: data[0]["dt_io"],
        };
        const response2 = await axios.post(
          "/snotes/searchFifoInv",
          requestBody2,
          {
            headers: {
              "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
            },
          }
        );

        const data2 = response2.data;
        if (data2.length > 0) {
          let minDtIo = data2[0]["dt_io"];
          let isAllOk = true;

          for (const item of data2) {
            if (!barcodeList.includes(item.no_barcode)) {
              isAllOk = false;
              // 바코드 안찍힌 목록 중 입고날짜가 더 크거나 같으면
              if (item.dt_io >= minDtIo) {
                minDtIo = item.dt_io;
                break;
              }
            }
          }

          const scanDtIo = data[0]["dt_io"];

          // 전체 스캔됐다면 현 바코드가 최소입고일
          if (isAllOk) {
            minDtIo = scanDtIo;
          }

          if (scanDtIo > minDtIo) {
            const dtIo = converter.formatToyyyyMMdd(minDtIo);
            switch (tpFifo) {
              case "DDW":
              case "MMW":
              case "YYW":
                // 경고메시지
                await showDialog(
                  "alter",
                  `선입선출 경고품목\r\n원입고일 [${dtIo}] 재고가 있습니다.`
                );
                break;
              case "DDX":
              case "MMX":
              case "YYX":
                await showDialog(
                  "alter",
                  `선입선출 통제품목\r\n원입고일 [${dtIo}] 재고가 있습니다.`
                );
                throw new Error();
            }
          }
        }
      }
    }
    return data;
  } catch (error) {
    return null;
  }
};

/** * BF창고 바코드스캔 cd_wh
 * * param: cd_firm, cd_biz, cd_wh, no_barcode
 * * return cd_firm, no_io, no_line_io, cd_item, nm_item
 *          dc_item_spec, dc_item_unit, fg_unit, cd_wh, qt_inv,
 *          no_lot, no_sn, no_origin, no_line_origin
 */
export const fnGetBarcodeScanBfInv = async (params: any) => {
  try {
    const requestBody = {
      ...params,
      cd_firm: global.getState().userInfo.cd_firm,
    };

    const response = await axios.post("/snotes/barcodeScanBfInv", requestBody, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;

    return data;
  } catch (error) {
    return null;
  }
};
